function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.4573 0H0V0.235653L3.29325 1.72098H24.1691L24.1552 5.46644H26.4573V0Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26.0053 22.8798H26.4574V8.54785H24.1553V39.0292H26.4574V23.7403H26.0053V22.8798Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M35.8993 5.5557L35.8853 1.72098H56.7612L60.0544 0.235653V0H33.6006V5.46287H33.7919C34.5291 5.46287 35.2246 5.49857 35.9027 5.55213L35.8993 5.5557Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M33.5967 8.54785V22.8763L35.8988 22.7477V8.54785H33.5967Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M33.5967 39.0293H35.8988V23.9118L33.5967 23.7476V39.0293Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M18.6393 41.4823V23.7405H23.2749V22.88H18.6393V6.3557H34.1632C40.5341 6.3557 43.6326 9.07642 43.6326 14.6678C43.6326 19.2809 41.4765 21.9231 37.0808 22.6872L35.895 22.7514V23.9154L37.0808 24.0011C42.405 24.7188 45.1071 27.6145 45.1071 32.6524C45.1071 38.7616 42.1407 41.4859 35.4916 41.4859H35.895V42.3571C43.5769 42.1393 48.143 38.5152 48.143 32.5489C48.143 27.4002 44.422 23.9476 38.3397 23.3299C43.1388 22.6122 46.6198 19.0667 46.6198 14.6714C46.6198 9.35135 42.7388 6.10576 35.8985 5.55948V5.62732H33.5963V5.47021H26.4569H24.1547H16.0381V42.3785H24.1582V41.4894H18.6428L18.6393 41.4823Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M33.5095 22.8795H26.457V23.74H33.3565L33.5095 23.7436L33.5965 23.7472V22.876L33.5095 22.8795Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M33.597 41.4819H26.4541V42.371H33.597V41.4819Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M26.457 22.8799H26.0049V23.7404H26.457V22.8799Z",
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M35.8988 5.62341V5.55557C35.2207 5.50201 34.5252 5.46631 33.7879 5.46631H33.5967V5.62341H35.8988Z",
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M33.5967 23.7473L35.8988 23.9115V22.7476L33.5967 22.8761V23.7473Z",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M54.782 31.085C53.9996 36.5014 51.5861 41.5073 47.7434 45.4491C44.4293 48.8518 40.3466 51.1726 35.8988 52.2616V42.3535C35.6519 42.3606 35.4154 42.3749 35.1616 42.3749H33.5967V52.7222V55.0002C39.5259 54.2075 45.0066 51.4583 49.3014 47.0487C53.8118 42.4177 56.5486 36.4479 57.1537 30.0103H57.0494L54.7785 31.0814L54.782 31.085Z",
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M35.8988 42.3531V41.4819H35.4954C35.4954 41.4819 35.492 41.4819 35.4885 41.4819H33.5967V42.371H35.1616C35.412 42.371 35.6519 42.3567 35.8988 42.3496V42.3531Z",
  fill: "white"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M24.1547 52.2613C19.7104 51.1687 15.6277 48.8515 12.3136 45.4488C8.48829 41.5212 6.07486 36.5368 5.28545 31.1418L2.90332 30.0171C3.51189 36.4511 6.24526 42.421 10.7557 47.0484C15.0505 51.4579 20.5311 54.2072 26.4569 54.9999V42.371H24.1582V52.2577L24.1547 52.2613Z",
  fill: "white"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M26.4539 41.4819H24.1553V42.371H26.4539V41.4819Z",
  fill: "white"
});

function SvgLogoBayHarborWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 55,
    viewBox: "0 0 61 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBayHarborWhite);
export default __webpack_public_path__ + "static/media/logo-bay-harbor-white.8c14a955d8d9c11dc7d695e68ba297e4.svg";
export { ForwardRef as ReactComponent };